import React from "react";
import { Map } from "../../common/components/map";
import { BollinoDto, ScadenzaDto, TipoScadenza } from "../../generated";
import DatesHelper from "../../common/datesHelper";

interface Props {
    expirations: ScadenzaDto[];
}
class Svgs {
    static ExpirationIcon(options: { color: string, scale?: number, rotation?: number, labelOrigin?: { x: number, y: number }, opacity?: number }) {
        return {
            path: `M409.133,109.203c-19.608-33.592-46.205-60.189-79.798-79.796C295.736,9.801,259.058,0,219.273,0
            c-39.781,0-76.466,9.801-110.063,29.407c-33.595,19.604-60.192,46.201-79.8,79.796C9.801,142.8,0,179.489,0,219.267
            s9.804,76.463,29.407,110.062c19.607,33.585,46.204,60.189,79.799,79.798c33.597,19.605,70.283,29.407,110.063,29.407
            s76.47-9.802,110.065-29.407c33.593-19.602,60.189-46.206,79.795-79.798c19.603-33.599,29.403-70.287,29.403-110.062
            C438.533,179.489,428.732,142.795,409.133,109.203z M255.82,356.021c0,2.669-0.862,4.9-2.573,6.707s-3.806,2.711-6.283,2.711
            h-54.818c-2.472,0-4.663-0.952-6.565-2.854c-1.904-1.903-2.854-4.093-2.854-6.563V301.78c0-2.478,0.95-4.668,2.854-6.571
            c1.903-1.902,4.093-2.851,6.565-2.851h54.818c2.478,0,4.579,0.907,6.283,2.707c1.711,1.817,2.573,4.045,2.573,6.715V356.021z
             M255.246,257.812c-0.192,1.902-1.188,3.568-2.991,4.996c-1.813,1.424-4.045,2.135-6.708,2.135h-52.822
            c-2.666,0-4.95-0.711-6.853-2.135c-1.904-1.428-2.857-3.094-2.857-4.996L178.162,80.51c0-2.288,0.95-3.997,2.852-5.14
            c1.906-1.521,4.19-2.284,6.854-2.284h62.819c2.666,0,4.948,0.76,6.851,2.284c1.903,1.143,2.848,2.856,2.848,5.14L255.246,257.812z`,
            fillColor: options.color,
            fillOpacity: options.opacity ?? 0.95,
            scale: options.scale || (1 / 25),
            strokeColor: "#9575AB",
            strokeWeight: 1,
            rotation: options.rotation || 0,
            labelOrigin: options.labelOrigin,
        }
    };
}

class MarkerSymbols {
    static ExpirationIcon(tipo: TipoScadenza) {
        switch (tipo) {
            case TipoScadenza.ControlloAnnuale:
                return Svgs.ExpirationIcon({ color: "#26c6da", scale: (1 / 18) });
            case TipoScadenza.ControlloCombustione:
                return Svgs.ExpirationIcon({ color: "#ffb22b", scale: (1 / 18) });
            default:
                return Svgs.ExpirationIcon({ color: "#fc4b6c", scale: (1 / 18) });
        }

    }
    static PitStop() {
        return {
            url: "/images/clock.svg",
            size: {
                height: 28,
                width: 28
            },
        };
    }
}

const ExpirationDetail = (scadenza: ScadenzaDto) => {
    const { indirizzo, comune, nome, cognome, marca, modello, dataUltimoControlloAnn, dataUltimoControlloComb } = scadenza;
    // const { cliente } = impianto;
    const lastBollino: BollinoDto = null!;
    return `<div>
        <h3>${nome} ${cognome}</h3>        
        <div>${indirizzo} ${comune}</div>
        <div>${marca} ${modello}</div>
        <div><strong class="me-2">Ult.Contr.Ann:</strong> ${DatesHelper.getReadableDateString(dataUltimoControlloAnn)}</div>
        <div><strong class="me-2">Ult.Contr.Comb:</strong>${DatesHelper.getReadableDateString(dataUltimoControlloComb)}</div>              
        ${lastBollino != null
            ? `<div><strong class="me-2">Ult.Bollino:</strong> ${DatesHelper.getReadableCompactDateString(lastBollino.validity.from)}-${DatesHelper.getReadableCompactDateString(lastBollino!.validity.to)}</div>`
            : ""}            
    </div>`
}

export const ExpirationMap: React.SFC<Props> = ({ expirations }) => {
    const map = React.createRef<Map>();
    const validExpirations = expirations.filter(x => x.lat && x.lon);
    React.useEffect(() => {
        for (const expiration of validExpirations) {
            map.current?.Api.addMarker({
                lat: expiration.lat!,
                lng: expiration.lon!,
                label: expiration.cognome,
                draggable: false,
                icon: MarkerSymbols.ExpirationIcon(expiration.tipologiaScadenza),
                infoWindowContent: ExpirationDetail(expiration)
            })
        }
    });
    const centerLat = validExpirations.length > 0 ? validExpirations[0].lat! : 43.114957;
    const centerLng = validExpirations.length > 0 ? validExpirations[0].lon! : 12.468938;
    const zoom = validExpirations.length > 0 ? 11 : 5;
    return (
        <Map
            defaults={{ centerLat, centerLng, zoom }}
            ref={map} />
    );

}
